/**
 * @fileoverview FootballLoader — uniform loading animation for ClubOS
 * Usage: <FootballLoader /> or <FootballLoader label="Loading fees…" />
 */
import PropTypes from "prop-types";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

function FootballLoader({ label = "Loading…", minHeight = 120 }) {
  return (
    <SoftBox
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={1}
      sx={{ minHeight, py: 4 }}
    >
      <SoftBox
        sx={{
          fontSize: "2.4rem",
          lineHeight: 1,
          display: "inline-block",
          animation: "fbBounce 0.9s ease-in-out infinite alternate",
          "@keyframes fbBounce": {
            "0%":   { transform: "translateY(0) rotate(0deg)" },
            "100%": { transform: "translateY(-12px) rotate(30deg)" },
          },
        }}
      >
        ⚽
      </SoftBox>
      <SoftBox
        sx={{
          width: 100,
          height: 3,
          borderRadius: 2,
          background: "linear-gradient(90deg, #1a73e8 0%, #17c1e8 100%)",
          animation: "fbBar 0.9s ease-in-out infinite alternate",
          "@keyframes fbBar": {
            "0%":   { opacity: 0.25, transform: "scaleX(0.3)" },
            "100%": { opacity: 1,    transform: "scaleX(1)" },
          },
          transformOrigin: "center",
        }}
      />
      <SoftTypography variant="caption" color="text" sx={{ mt: 0.5 }}>
        {label}
      </SoftTypography>
    </SoftBox>
  );
}

FootballLoader.propTypes = {
  label: PropTypes.string,
  minHeight: PropTypes.number,
};

export default FootballLoader;
